<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-header">
      <h3 class="text-black fw-semibold">Modifier un produit</h3>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form ref="produitForm" @submit="editProduit" :validation-schema="produitSchema" :initial-values="produitForm">
        <div class="row gx-1">
          <div class="col-md-12">
            <div class="row row gx-2">
              <div class="col-md-12">
                <div class="row gx-1">
                  <div class="col-md-3">
                    <div class="form-group mb-3 mb-sm-3 mb-md-3">
                      <label class="d-block text-black fw-semibold mb-1">
                        Code du produit
                      </label>
                      <Field type="text" v-model="codeProduit" name="code"
                        class="form-control shadow-none fs-md-15 text-black" readonly="true"
                        placeholder="Ce code est généré" />
                      <ErrorMessage name="code" class="text-danger" />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group mb-3 mb-sm-3 mb-md-3">
                      <label class="d-block text-black fw-semibold mb-1">
                        Référence usine du produit
                      </label>
                      <Field name="refProd" type="text" class="form-control shadow-none fs-md-15 text-black"
                        placeholder="Entrer la référence" />
                      <ErrorMessage name="refProd" class="text-danger" />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group mb-3 mb-sm-3 mb-md-3">
                      <label class="d-block text-black fw-semibold mb-1">
                        Famille du produit<span class="text-danger">*</span>
                      </label>
                      <Field name="famille" v-slot="{ field }" v-model="famille">
                        <Multiselect :options="familleOptions" :searchable="true" track-by="label" label="label"
                          v-model="field.value" v-bind="field" @select="selectFamille(field.value)"
                          placeholder="Sélectionner la famille" />
                      </Field>
                      <ErrorMessage name="famille" class="text-danger" />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group mb-sm-2 mb-md-2" ref="dropdownRef">
                      <label class="d-block text-black fw-semibold mb-1">
                        Nom du Produit<span class="text-danger">*</span>
                      </label>
                      <Field name="nomProd" type="text" v-model="prodName" @focus="showBox = true"
                        class="mb-2 form-control shadow-none fs-md-15 text-black"
                        placeholder="Entrer le nom du produit" />
                      <ul class="dropdown-menu show " v-if="produitOptions.length > 0 && showBox==true">
                        <li v-for="(produit, index) in produitOptions" :key="index">
                          <a class="dropdown-item" href="javascript:void(0);">{{ produit.codeProduit }} - {{
                            produit.nomProd }}</a>
                        </li>
                      </ul>
                      <ErrorMessage name="nomProd" class="text-danger" />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group mb-3 mb-sm-3 mb-md-3">
                      <label class="d-block text-black fw-semibold mb-1">
                        Unité de Stockage
                      </label>
                      <Field name="uniteStock" v-slot="{ field }">
                        <Multiselect :options="conditionnementOptions" :searchable="true" track-by="label" label="label"
                          v-model="field.value" v-bind="field" placeholder="Choisir l'unité de stockage" />
                      </Field>
                      <ErrorMessage name="uniteStock" class="text-danger" />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group mb-3 mb-sm-3 mb-md-3">
                      <label class="d-block text-black fw-semibold mb-1">
                        Unité de gestion
                      </label>
                      <Field name="uniteGestion" v-slot="{ field }">
                        <Multiselect :options="conditionnementgOptions" :searchable="true" track-by="label"
                          label="label" v-model="field.value" v-bind="field" placeholder="Choisir l'unité de gestion" />
                      </Field>
                      <ErrorMessage name="uniteGestion" class="text-danger" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-8">
            <div class="form-group mb-3 mb-sm-3 mb-md-3">
              <label class="d-block text-black fw-semibold mb-1">
                Description du produit
              </label>
              <Field name="descProd" as="textarea" cols="15" rows="1" placeholder="Entrer la description"
                v-slot="{ field }" class="form-control shadow-none rounded-0 text-black">
                <textarea class="form-control shadow-none rounded-0 text-black" v-model="field.value"></textarea>
              </Field>
              <ErrorMessage name="descProd" class="text-danger" />
            </div>
          </div>
          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-1">
                    Seuil d'approvisionnement
                </label>
                <Field name="seuilAppro" type="number"
                    class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer le seuil d'approvisionnement" />
                <ErrorMessage name="seuilAppro" class="text-danger" />
            </div>
        </div>

          <div class="col-md-3" v-for="(champsLibre, index) in chamsdescritifs" :key="index">
            <div class="form-group mb-3 mb-sm-3 mb-md-3">
              <label class="d-block text-black fw-semibold mb-1">
                {{ champsLibre.libelleChamp }} <span class="text-danger" v-if="champsLibre.estObligatoire == 1">*</span>
              </label>
              <input
                :class="(valideteRowProduit(champsLibre.valeur) && champsLibre.estObligatoire == 1) ? 'form-control shadow-none fs-md-15 text-black is-invalid ' : 'form-control shadow-none fs-md-15 text-black '"
                v-model="champsLibre.valeur" :name="champsLibre.nomChamp" :type="champsLibre.typeChamp" />
              <div v-if="valideteRowProduit(champsLibre.valeur) && champsLibre.estObligatoire == 1" class="text-danger">
                {{ champsLibre.libelleChamp }} est obligatoire.
              </div>
            </div>
          </div>


          <div class="col-md-12">
            <div class="d-flex align-items-center">
              <button class="btn btn-success me-3" type="submit">
                Modifier un produit
              </button>
              <router-link to="/produits/liste-produits" class="btn btn-danger"><i
                  class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                <span class="position-relative"></span>Annuler</router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent, ref, onMounted, reactive, watch, onBeforeUnmount } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import { error, success } from '@/utils/utils';
import { useRoute, useRouter } from 'vue-router';
import ApiService from '@/services/ApiService';
import { Produit } from '@/models/Produit';
import * as Yup from 'yup';
import Multiselect from '@vueform/multiselect'
import DropZone from "dropzone-vue";
import { ChampsLibre } from "@/models/ChampsLibre";
import axios from 'axios';

export default defineComponent({
  name: "EditProduit",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,
    DropZone
  },
  setup: () => {
    const produitSchema = Yup.object().shape({
      refProd: Yup.string().notRequired(),
      nomProd: Yup.string().required("Le nom est obligatoire"),
      famille: Yup.string().required("La famille est obligatoire"),
      uniteGestion: Yup.string().notRequired(),
      uniteStock: Yup.string().notRequired(),
      descProd: Yup.string().notRequired(),
      seuilAppro: Yup.number().notRequired(),
    });
    const produitForm = ref<Produit | null>(null);
    const router = useRouter();
    const route = useRoute();
    const familleOptions = ref([]);
    const prodName = ref("");
    const codeProduit = ref("");

    const isDisableCha = ref(false);
    const defaultImage = 'path/to/your/default-image.jpg'; // Chemin de l'image par défaut
    const hasFiles = ref(false); // Indicateur pour savoir si des fichiers ont été déposés
    const conditionnementOptions = ref([]);
    const produitOptions = ref([]);
    const prixProd = ref();
    const produitsss: any = ref(null);
    const valuess = ref();
    const chamsdescritifs = reactive<Array<ChampsLibre>>([]);


    const dropzoneOptions = {
      url: 'your-upload-url', // URL de téléchargement des fichiers
      thumbnailWidth: 150,
      maxFilesize: 2,
      headers: { "My-Awesome-Header": "header value" }
    };

    const onSuccess = (file) => {
      hasFiles.value = true; // Mettre à jour l'indicateur lorsqu'un fichier est déposé avec succès
    };

    const onError = (file, message) => {
      console.error('File upload error:', message);
    };

    const montantTotal = ref(0);
    const isDisable = ref(true);
    const isDisablee = ref(true);
    const famille = ref();
    const conditionnementgOptions = ref([]);
    const uniteStock = ref();
    const showBox = ref(false);

    function getProduit(id: number) {
      ApiService.get("/produits/" + id.toString())
        .then(({ data }) => {
          console.log(data.data, "datadatadatadatadatadatadatadata");
          for (const key in data.data) {
            produitForm.value?.setFieldValue(key, (typeof data.data[key] === 'object' && data.data[key] !== null) ? data.data[key].id : data.data[key]);
          }
          produitForm.value?.setFieldValue("famille", data.data["famille"].id)
          console.log("famille ===> ", data.data["famille"])
          famille.value = parseInt(data.data["famille"].id);
          uniteGestion.value = parseInt(data.data["uniteGestion"].id);
          uniteStock.value = parseInt(data.data["uniteStock"].id);
          codeProduit.value = data.data["codeProduit"];

          if (data.data["produitchampslibres"] != null) {
            data.data["produitchampslibres"].forEach(element => {
              chamsdescritifs.push({
                id: parseInt(element.champslibre.id),
                libelleChamp: element.champslibre.libelleChamp,
                estObligatoire: element.champslibre.estObligatoire,
                typeChamp: element.champslibre.typeChamp,
                nomChamp: element.champslibre.nomChamp,
                valeur: element.valeur,
                idProChamp: (element.id) ? parseInt(element.id) : null,
              });
            });

          }

          console.log("FOOROROROROROMMM ===> ", famille.value)
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    }

    const editProduit = async (values, { resetForm }) => {
      values["famille"] = famille.value;
      values.champsdescritifs = chamsdescritifs.map(champsdescritif => ({
        champslibre: champsdescritif.id,
        valeur: champsdescritif.valeur,
        idProChamp: (champsdescritif.idProChamp) ? champsdescritif.idProChamp : null
      }));
      console.log(values, "valuesvaluesvaluesvalues");
      ApiService.put("/produits/" + route.params.id, values)
        .then(({ data }) => {
          console.log(data, "datadatadatadatadatadatadatadata");
          if (data.code == 200) {
            success(data.message);
            resetForm();
            router.push({ name: "ListeProduit" });
          }
        }).catch(({ response }) => {
          error(response.message);
        });
    };

    const fetchAllChamps = async (id) => {
      try {
        const response = await axios.get("/champsdescritif/famille/" + id);
        console.log(response.data, "response.dataresponse.dataresponse.data");
        chamsdescritifs.length = 0;
        response.data.data.forEach(element => {
          chamsdescritifs.push(element.champslibre);
        });
        console.log(chamsdescritifs, "chamsdescritifs.valuechamsdescritifs.value");

      } catch (error) {
        //
      }
    };

    const fetchFamille = async () => {
      try {
        const response = await ApiService.get('/all/all/familles');
        const familleData = response.data.data.data;
        familleOptions.value = familleData.map((famille) => ({
          value: famille.id,
          label: `${famille.codeFamille} - ${famille.libelleFamille}`,
        }));
      } catch (error) {
        //
      }
    };

    const fetchProduis = async (newValue) => {
      try {
        const response = await ApiService.get(`produits/recherche?keyword=${newValue}&type=0`);
        console.log(response, "responseresponseresponseresponse");
        produitOptions.value = response.data.data;
      } catch (error) {
        //
      }
    };

    watch(prodName, (newValue, oldValue) => {
      if (newValue && newValue.length >= 3) {
        fetchProduis(newValue);
      } else {
        produitOptions.value = [];
      }
    })

    const selectFamille = (value) => {
      console.log(value, "valuevaluevaluevalue");
      if (parseInt(value) > 0) {
        fetchAllChamps(parseInt(value));
      } else {
        chamsdescritifs.length = 0;
      }
    }

    const getCurrentDate = () => {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, "0");
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const year = today.getFullYear();
      return `${year}-${month}-${day}`;
    };


    watch(chamsdescritifs, (newValue, oldValue) => {
      const newValueLast = newValue.filter(order => order.estObligatoire == 1);
      console.log(newValueLast, "newValueLastnewValueLast");
      Object.keys(newValueLast).forEach(function (key) {
        if (newValueLast[key].valeur == "" || newValue[key].valeur == 0) {
          if (newValueLast[key].estObligatoire == 1) {
            isDisableCha.value = true;
            console.log(isDisableCha.value, "isDisableCha.value true");
          }
        } else {
          isDisableCha.value = false;
          console.log(isDisableCha.value, "isDisableCha.value false");
        }
      });
    });

    const fetchConditionnements = async () => {
      try {
        const response = await axios.get("/conditionnements");
        const conditionnementsData = response.data.data;
        produitsss.value = conditionnementsData;
        conditionnementOptions.value = conditionnementsData.map((conditionnement) => ({
          value: conditionnement.id,
          label: `${conditionnement.libelle}`,
        }));
      } catch (error) {
        //
      }
    };

    const fetchConditionnementugs = async () => {
      try {
        const response = await axios.get("/conditionnementugs");
        const conditionnementgData = response.data.data;
        produitsss.value = conditionnementgData;
        conditionnementgOptions.value = conditionnementgData.map((conditionnement) => ({
          value: conditionnement.id,
          label: `${conditionnement.libelle}`,
        }));
      } catch (error) {
        //
      }
    };


    const uniteGestion = ref(null);

    const valideteRowProduit = (e) => {
      if (e == "" || e == 0 || e == "0" || e == null || e < 0) {
        return true;
      } else {
        return false;
      }
    };

    const dropdownRef = ref(null);

    function handleClickOutside(event) {
      if (dropdownRef.value && !dropdownRef.value.contains(event.target)) {
        showBox.value = false;
      }
    }

    onBeforeUnmount(() => {
      document.removeEventListener('click', handleClickOutside);
    });

    onMounted(async () => {
      document.addEventListener('click', handleClickOutside);
      await fetchFamille();
      await fetchConditionnements();
      await fetchConditionnementugs();
      if (route.params.id) {
        await getProduit(parseInt(route.params.id as string));
      }
    });

    return {
      editProduit,
      codeProduit,
      produitOptions,
      uniteGestion,
      prodName,
      hasFiles,
      produitForm,
      familleOptions,
      valideteRowProduit,
      fetchConditionnementugs,
      conditionnementgOptions,
      conditionnementOptions,
      montantTotal,
      valuess,
      prixProd,
      isDisable,
      isDisablee,
      getCurrentDate,
      isDisableCha,
      dropzoneOptions,
      onSuccess,
      onError,
      defaultImage,
      chamsdescritifs,
      selectFamille,
      produitSchema,
      famille,
      showBox,
      dropdownRef
    };
  },
});
</script>
<style scoped>
.dropzone-container {
  position: relative;
  width: 100%;
  max-width: 500px;
  margin: auto;
}

.default-image-container {
  text-align: center !important;
  margin: 20px 0 !important;
}

.default-image {
  width: 100px !important;
  height: auto !important;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

.marge-droite {
  margin-left: 15px;
}

.hr-longeur {
  width: 80%;
}

.bord1 {
  border: 1px solid #07a;
}

.fond {
  background-color: rgb(94, 191, 233);
}

@import 'dropzone-vue/dist/dropzone-vue.common.css';
</style>